import React from 'react';
import RecentLogs from './RecentLogs';

export default function RecentLogsPage({ onRerun }) {
  return (
    <section className="relative mx-auto w-full max-w-5xl px-6 pb-24 pt-28 text-white lg:px-16">
      <div className="pointer-events-none absolute inset-x-0 top-10 -z-10 h-64 rounded-full bg-gradient-to-r from-[#8b5cf6]/25 via-transparent to-[#ec4899]/25 blur-3xl" />
      <header className="mb-10 space-y-4">
        <p className="text-sm uppercase tracking-[0.35em] text-white/60">Session history</p>
        <h1 className="text-4xl font-semibold leading-tight md:text-5xl">Recent Logs</h1>
        <p className="max-w-2xl text-lg text-white/70">
          Review the inputs and intermediate steps from your latest NumSolve sessions. Export logs for documentation or further analysis.
        </p>
      </header>
      <RecentLogs className="border-none bg-transparent p-0 shadow-none" 
       logItemClass="bg-transparent" 
      onRerun={onRerun} />
    </section>
  );
}
